import styled from 'styled-components';
import { theme } from '../../../../../theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const { colors } = theme;

export const H2 = styled.h2`
  margin: 0;
  font-size: 1.4rem;
  font-weight: 600;
  color: ${colors.textPrimary};
`;

export const SpanCounter = styled.span`
  margin-left: 1.2rem;
  font-size: 1.2rem;
  color: ${colors.textDeaccent};
`;

export const FontAwesomeIconStyled = styled(FontAwesomeIcon)`
  margin-right: 1rem;
  color: ${colors.error};
`;

export const SpanLabel = styled.span`
  margin-right: 0.8rem;
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1;
  color: ${colors.textDeaccent};
`;

export const SpanValue = styled(SpanLabel)`
  font-weight: 500;
`;

export const SpanSecondLine = styled.span`
  width: 100%;
  display: inline-flex;
  flex-wrap: wrap;
  align-items: flex-end;
`;

export const SpanAction = styled.span`
  margin-left: auto;
`;
